module.exports = __webpack_public_path__ + "img/1.0bf8136e.png";